import { IsArray, IsBoolean, IsInt, IsNumber, IsOptional, IsString } from 'class-validator'

export class CreateUpdateTruckDto {
  @IsNumber()
  @IsOptional()
  id?: number

  @IsString()
  name!: string

  @IsString()
  @IsOptional()
  provider?: string

  @IsBoolean()
  @IsOptional()
  active?: boolean

  @IsNumber()
  @IsInt()
  @IsOptional()
  regionId?: number

  @IsNumber()
  @IsInt()
  @IsOptional()
  factoryId?: number

  @IsNumber()
  @IsInt()
  typeId?: number

  @IsArray()
  @IsInt({ each: true })
  cropTypeIds?: number[]
}
